import mapActions from './mapActions';

export default mapActions('tablet_owners', {
    fetchAll_url: (id) => `/api/tablets/${id}/history`
});